import React from "react"
import { Checkbox as MuiCheckbox, FormGroup, FormControlLabel, CheckboxProps } from "@mui/material"

type Props = CheckboxProps & {
  label: string
}

export const Checkbox: React.FC<Props> = ({ label, sx, ...rest }) => {
  const formControlLabelStyle = {
    "& .MuiFormControlLabel-label": {
      fontFamily: "Noto Sans JP !important",
      color: "text.primary",
    },
  }

  return (
    <FormGroup>
      <FormControlLabel
        label={label}
        sx={{ ...formControlLabelStyle }}
        control={
          <MuiCheckbox
            sx={{
              color: "text.primary",
              ...sx,
            }}
            {...rest}
          />
        }
      />
    </FormGroup>
  )
}
